import { FormattedMessage } from 'components/shared/Intl';
import { FC } from 'react';

import { connectedBatchToolbarMetadata } from './BatchToolbarMetadata.connect';
import type { BatchToolbarMetadataProps } from './BatchToolbarMetadata.models';

export const BatchToolbarMetaComponent: FC<BatchToolbarMetadataProps> = ({ numberOfQuotesSelected }) => {
  return (
    <div className="flex-fill d-flex align-items-center justify-content-sm-start justify-content-md-end mx-1">
      {numberOfQuotesSelected > 0 && (
        <span className="badge rounded-pill badge-primary">
          <span data-e2e="batch-nb-quotes-selected">{numberOfQuotesSelected}</span>
          <span className="d-none d-xl-inline">
            &nbsp;
            <FormattedMessage id="batchPricer.quotesSelected" />
          </span>
        </span>
      )}
    </div>
  );
};

export const BatchToolbarMetadata = connectedBatchToolbarMetadata(BatchToolbarMetaComponent);
